module.exports = __webpack_public_path__ + "assets/HKNova-Heavy.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Heavy.svg
// module id = 126
// module chunks = 0